var React = require('react');

function Tree (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 21.5H17.6922C17.837 21.5 17.9338 21.351 17.875 21.2188L16 17M14.5 14H15.6922C15.837 14 15.9338 13.851 15.875 13.7188L14 9.5M14 6.5L12.1828 2.41122C12.1124 2.25285 11.8876 2.25285 11.8172 2.41122L10.125 6.21877C10.0662 6.35103 10.163 6.5 10.3078 6.5H11.5M10 9.5L8.12499 13.7188C8.06621 13.851 8.16302 14 8.30775 14H8.68596C8.83228 14 8.92908 14.152 8.8672 14.2846L5.6328 21.2154C5.57092 21.348 5.66772 21.5 5.81404 21.5H7.5","stroke":"#2B1F2E","strokeWidth":"1.5","strokeLinecap":"round"}));
}

Tree.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Tree;

Tree.default = Tree;
